export const SOCKET_URL = `${process.env.REACT_APP_ADMIN_API_URL}/workplace`;
